<template>
  <section class="section">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
          <div class="box-style line-top">
            <div class="box-header">
              <h1>DETALLES DE TU PEDIDO GRUPAL</h1>
              <div class="box-date"><a href="" type="button" class="regular" @click.prevent="cancelarClicked"><i class="fa fa-times" ></i> cancelar pedido</a></div>
            </div>
          </div>
          <div class="box-body" v-if="user">
            <p class="text-size-18">Administrador Grupal: <span class="regular">{{user.displayName}}</span></p>
            <!--
            <p class="text-size-18">Fecha: <span class="regular">Hoy, Lunes 14 de Marzo</span></p>
            -->
            <p class="text-size-18">Empresa: <span class="regular">{{user.sucursalAsociada.denominacion}}-{{user.sucursalAsociada.empresa.razonSocial}}</span></p>
            <p class="text-size-18">Teléfono: <span class="regular">{{user.telefonoCelular}}</span></p>
            <p class="text-size-18">Dirección de entrega: <span class="regular">{{user.sucursalAsociada.direccion.direccion}}</span></p>
          </div>
          <div class="box-header subline-top">
            <h1>ASIGNAR PLATOS A EMPLEADOS</h1>
          </div>
          <div class="box-header">
            <h2>AÚN SIN ASIGNAR</h2>
          </div>
          <template v-for="itemMenu, idx in carrito" v-if="users">
            <h4 class="text-right">{{itemMenu.fecha | fechaFormateadaEncabezado}}</h4>
            <template v-for="proveedor, idxProveedor in itemMenu.proveedor">
              <div class="table-container margin-20" v-for="plato, idxPlato in proveedor.platos">
                <table class="table table-hover table-stripped table-responsivo table-checkout no-margin">
                  <tbody>
                    <tr>
                    <td class="col-sm-1">
                      <b>{{calcularSinAsignar(plato)}}</b>
                    </td>
                    <td class="col-sm-5">
                      <select-empleados v-if="calcularSinAsignar(plato) > 0" :plato="plato.plato" :fecha="itemMenu.fecha" @select-empleado="onSelectEmpleado" :key="idx +'-' + idxProveedor +'-' + idxPlato" :usuarios="users" :exclusiones="plato.asignaciones" :combo="comboActivo" :admin="user"></select-empleados>
                      <span class="label label-info" v-else>Plato completamente asignado</span>
                    </td class="col-sm-6">
                    <td>{{plato.plato.nombre}}</td>
                    <td>
                      <div class="quantity-actions text-right">
                        <div class="quantity">
                          <!--<a class="decrease" href="javascript:void(0);">–</a>-->
                          <span class="qty-value">{{plato.cantidad}}</span>
                          <!--<a class="increase" href="javascript:void(0);">+</a>-->
                        </div>
                      </div>
                    </td>
                    <!--
                    <td class="col-sm-1"> $99.99</td>
                    -->
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>
          </template>
          
          <div class="box-header">
            <h2>ASIGNADOS</h2>
          </div>
          <div class="table-container margin-20">
            <template v-for="item, idxItem in carrito">
              <div class="date pull-right m-r-20 gris"><span>{{item.fecha | fechaFormateadaEncabezado}}</span></div>
              <template v-for="proveedor in item.proveedor">
                <table class="table table-hover table-stripped table-responsivo table-checkout no-margin">
                  <tbody>
                    <!--
                    <template v-for="plato, idxPlato in proveedor.platos" >
                      <tr v-for="asignacion in plato.asignaciones">
                        <td><i class="fa fa-user-circle" :class="{verde: estaCompletoMenuUsuarioDia(item.fecha, asignacion.idEmpleado)}"></i>&nbsp;{{nombreEmpleado(asignacion.idEmpleado)}}</td>
                        <td>{{plato.plato.nombre}}</td>
                        <td >
                          <div class="pull-right">
                            <span>{{asignacion.cantidad}}</span>
                            <a class="btn btn-xs btn-ghost btn-eliminar" type="button" @click="desasignarPlato(item.fecha, plato.plato, asignacion.idEmpleado)">
                              <i class="fa fa-actions fa-times" v-if="asignacion.cantidad === 1"></i>
                              <i class="fa fa-actions fa-minus" v-else=""></i>
                            </a>
                          </div>
                        </td>
                      </tr>
                    </template>
                    -->
                    <template v-for="usuario in usuariosConPlatoDia(item.fecha)" v-if="usuariosConPlatoDia(item.fecha).length > 0">
                      <tr v-for="asignacion, idx in getAsignacionesUsuarioDia(item.fecha, usuario._id)">
                        <td :rowspan="getAsignacionesUsuarioDia(item.fecha, usuario._id).length" v-if="idx === 0"><i class="fa fa-check-circle verde" aria-hidden="true" v-if="estaCompletoMenuUsuarioDia(item.fecha, asignacion.idEmpleado)"></i><i class="fa fa-warning" style="color: #f0ad4e;" v-else></i>&nbsp;{{usuario.displayName}}</td>
                        <td :class="{'text-danger':noDisponibles.indexOf(asignacion.idPlato)>=0}"><span class="label label-danger" v-if="noDisponibles.indexOf(asignacion.idPlato)>=0">Sin stock suficiente</span> {{getNombrePlato(asignacion.idPlato)}}</td>
                        <td>
                          <div class="pull-right">
                            <span>{{asignacion.cantidad}}</span>
                            <a class="btn btn-xs btn-ghost btn-eliminar" type="button" @click="desasignarPlato(item.fecha, asignacion.idPlato, asignacion.idEmpleado)">
                              <i class="fa fa-actions fa-times" v-if="asignacion.cantidad === 1"></i>
                              <i class="fa fa-actions fa-minus" v-else=""></i>
                            </a>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </template>
            </template>
          </div>
          <div class="box-body">
            <div class="box-actions text-center smart-form">
                <p class="text-center margin-bottom-20">
                  <label class="checkbox inline-block">
                    <input type="checkbox" name="checkbox" v-model="aceptaCondiciones">
                    <i></i>He revisado el pedido y es exactamente lo que quiero recibir
                  </label>
                </p>
              <button type="button" class="btn btn-primary btn-fill" :class="{disabled: !aceptaCondiciones}" @click.prevent="onClickConfirmar">CONFIRMAR</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import moment from 'moment'
  import SelectEmpleados from './../Shared/EmpleadosEmpresa'
  import SelectAsignacion from './ComboAsignarPlato'
  import localforage from 'localforage'
  import 'sweetalert2/dist/sweetalert2.css'
  import swal from 'sweetalert2'

  export default {
    mounted () {
      const me = this
      me.$emit('esconder-carrito')
      me.$http.get('/api/users/empleadosactivosempresa').then(({body}) => {
        const pedidosRealizados = body[2]
        me.users = body[0]
        me.users.forEach((user) => {
          console.log('user', user)
          let pedidos = pedidosRealizados.filter((pedido) => {
            return pedido.usuario === user._id
          })
          user.pedidos = pedidos || []
        })
      }, error => {
        console.log(error)
      })
    },
    data () {
      return {
        aceptaCondiciones: false,
        users: null,
        subsidio: null,
        combo: null,
        noDisponibles: []
      }
    },
    components: {
      'select-empleados': SelectAsignacion,
      'select-usuarios': SelectEmpleados
    },
    computed: {
      platosDistinct () {
        const me = this
        // let resultado = []
        let arrPlatos = []
        me.carrito.forEach((item) => {
          item.proveedor.forEach((proveedor) => {
            proveedor.platos.forEach((plato) => {
              arrPlatos.push(plato.plato)
            })
          })
        })
        return arrPlatos
      },
      comboActivo () {
        const me = this
        let valor = null
        if (me.carrito.length > 0) {
          valor = me.carrito[0].combo
        }
        return valor
      },
      subsidioActivo () {
        const me = this
        let subsidio = {}
        if (me.carrito.length > 0) {
          subsidio = me.subsidio.find((item) => {
            return item.combo._id === me.carrito[0].combo
          })
        }
        if (subsidio.hasOwnProperty('combo')) {
          me.combo = subsidio.combo._id
        }
        return subsidio
      }
    },
    props: ['user', 'carrito'],
    filters: {
      fechaFormateadaEncabezado (val) {
        return moment(new Date(val)).utc().format('dddd, DD [de] MMMM')
      }
    },
    methods: {
      arrDistinct (arrArg) {
        return arrArg.filter(function (elem, pos, arr) {
          return arr.indexOf(elem) === pos
        })
      },
      calcularSinAsignar (plato) {
        let total = 0
        if (plato.asignaciones) {
          plato.asignaciones.forEach((asignacion) => {
            total += asignacion.cantidad
          })
        }
        return plato.cantidad - total
      },
      cancelarClicked (e) {
        const me = this
        swal({
          title: 'Cancelar pedido',
          text: '¿Desea cancelar el pedido?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Si, cancelar',
          cancelButtonText: 'No, cerrar esta ventana'
        }).then(() => {
          me.$emit('vaciar-carrito')
          me.$emit('esconder-carrito')
          me.$router.push({
            path: '/hacerpedido'
          })
        }, (dismiss) => {
          return false
        })
      },
      desasignarPlato (fecha, idPlato, idEmpleado) {
        const me = this
        let plato = me.platosDistinct.find((pl) => {
          return pl._id === idPlato
        })
        me.$emit('desasignar-plato', {
          fecha: fecha,
          plato: plato,
          idEmpleado: idEmpleado
        })
      },
      estaCompletoMenuUsuarioDia (fecha, idEmpleado) {
        const me = this
        /*
        const itemFecha = me.carrito.find((itemCarrito) => {
          return itemCarrito.fecha === fecha
        })
        const subsidio = me.subsidio.find((item) => {
          return item.combo._id === itemFecha.combo
        })
        */
        let resultado = me.reglas.every((regla) => {
          let asignacionesCategoria = me.getPlatosCategoriaUsuarioDia(fecha, idEmpleado, regla.categoria._id)
          return asignacionesCategoria >= regla.cantidad
        })
        return resultado
      },
      estanTodosPlatosAsignados () {
        const me = this
        if (me.carrito.length < 1) {
          return false
        }
        let resultado = me.carrito.every((item) => {
          return item.proveedor.every((proveedor) => {
            return proveedor.platos.every((plato) => {
              if (plato.asignaciones) {
                let asignaciones = 0
                plato.asignaciones.forEach((asignacion) => {
                  asignaciones += asignacion.cantidad
                })
                return asignaciones === plato.cantidad
              } else {
                return false
              }
            })
          })
        })
        return resultado
      },
      getAsignacionesUsuarioDia (dia, idEmpleado) {
        const me = this
        let resultado = []
        let itemCarrito = me.carrito.find((itemCarrito) => {
          return itemCarrito.fecha === dia
        })
        if (itemCarrito) {
          let proveedor = itemCarrito.proveedor[0]
          if (proveedor.platos) {
            let platos = []
            itemCarrito.proveedor[0].platos.forEach((plato) => {
              if (plato.asignaciones) {
                let asignaciones = plato.asignaciones.filter((asignacion) => {
                  return asignacion.idEmpleado === idEmpleado
                })
                if (asignaciones) {
                  asignaciones.forEach((asignacion) => {
                    platos.push({
                      idEmpleado: asignacion.idEmpleado,
                      cantidad: asignacion.cantidad,
                      idCategoria: plato.plato.categoria._id,
                      idPlato: plato.plato._id
                    })
                  })
                }
              }
            })
            resultado = platos
          }
        }
        return resultado
      },
      getPlatosCategoriaUsuarioDia (dia, idEmpleado, idCategoria) {
        const me = this
        let asignaciones = me.getAsignacionesUsuarioDia(dia, idEmpleado)
        let contador = 0
        if (asignaciones.length > 0) {
          let filtrados = asignaciones.filter((asignacion) => {
            return asignacion.idCategoria === idCategoria
          })
          filtrados.forEach((item) => {
            contador += item.cantidad
          })
        }
        return contador
      },
      getNombrePlato (idPlato) {
        const me = this
        let nombre = ''
        let existePlato = me.platosDistinct.find((plato) => {
          return plato._id === idPlato
        })
        if (existePlato) {
          nombre = existePlato.nombre
        }
        return nombre
      },
      getReglaCategoria (idCategoria) {
        let existeRegla = this.reglas.find((regla) => {
          return regla.categoria._id === idCategoria
        })
        return existeRegla
      },
      getUserById (idUser) {
        let existeUser = this.users.find((user) => {
          return user._id === idUser
        })
        return existeUser
      },
      getUsersIdDistinctDia (dia) {
        const me = this
        let users = []
        const item = me.carrito.find((itemCarrito) => {
          return itemCarrito.fecha === dia
        })
        item.proveedor.forEach((proveedor) => {
          proveedor.platos.forEach((plato) => {
            if (plato.asignaciones) {
              plato.asignaciones.forEach((asignacion) => {
                users.push(asignacion.idEmpleado)
              })
            }
          })
        })
        let idsUnicos = me.arrDistinct(users)
        return idsUnicos
      },
      usuariosConPlatoDia (fecha) {
        const me = this
        if (!me.users) {
          return []
        }
        if (me.users.length < 1) {
          return []
        }
        let resultado = []
        let idsUsuarios = []
        let existeFecha = me.carrito.find((itemCarrito) => {
          return itemCarrito.fecha === fecha
        })
        if (existeFecha) {
          existeFecha.proveedor.forEach((proveedor) => {
            proveedor.platos.forEach((plato) => {
              if (plato.asignaciones) {
                plato.asignaciones.forEach((asignacion) => {
                  if (asignacion.idEmpleado) {
                    idsUsuarios.push(asignacion.idEmpleado)
                  }
                })
              }
            })
          })
        }
        let idsUnicos = me.arrDistinct(idsUsuarios)
        idsUnicos.forEach((idUsuario) => {
          let usuario = me.users.find((user) => {
            return user._id === idUsuario
          })
          resultado.push(usuario)
        })
        return resultado
      },
      nombreEmpleado (idEmpleado) {
        let nombre = ''
        let existeUser = this.users.find((user) => {
          return user._id === idEmpleado
        })
        if (existeUser) {
          nombre = existeUser.displayName
        }
        return nombre
      },
      onClickConfirmar () {
        const me = this
        if (!me.aceptaCondiciones) {
          me.$emit('mostrar-notificacion', 'Debe aceptar los términos y condiciones para continuar', 'error')
          return false
        }
        const estanPlatosAsignados = me.estanTodosPlatosAsignados()
        if (!estanPlatosAsignados) {
          me.$emit('mostrar-notificacion', 'Falta asignar platos', 'warning')
          return false
        }
        const pedidosCompletos = me.todosPedidosCompletos()
        if (!pedidosCompletos) {
          me.$emit('mostrar-notificacion', 'Hay pedidos que no están completos', 'error')
          return false
        }
        me.$emit('esconder-carrito')
        me.$emit('activar-modal')
        me.$http.post('/api/pedidos/pedidoadmin', {
          carrito: me.carrito
        }).then(({body}) => {
          me.$emit('vaciar-carrito')
          me.$emit('cerrar-modal')
          me.$router.push({
            path: '/mispedidos'
          })
        }, (err) => {
          me.$emit('cerrar-modal')
          console.log('error', err)
          me.noDisponibles = err.body.platos
          me.$emit('mostrar-notificacion', err.body.error, 'error')
        })
      },
      onSelectEmpleado (values) {
        const me = this
        if (me.puedePedirPlatoDia(values.fecha, values.idEmpleado, values.plato)) {
          me.$emit('asignar-plato', values)
        } else {
          me.$emit('mostrar-notificacion', 'No se pueden asignar más platos de esta categoría para el usuario en la fecha', 'error')
        }
      },
      puedePedirPlatoDia (dia, idEmpleado, plato) {
        const me = this
        let resultado = true
        let user = me.getUserById(idEmpleado)
        if (user.roles[0] !== 'admincliente') {
          let platosUsuarioEnEsaCategoria = me.getPlatosCategoriaUsuarioDia(dia, idEmpleado, plato.categoria._id)
          let reglaCategoria = me.getReglaCategoria(plato.categoria._id)
          if (platosUsuarioEnEsaCategoria >= reglaCategoria.cantidad) {
            resultado = false
          }
        }
        return resultado
      },
      todosPedidosCompletos () {
        const me = this
        // const idsUsuario = me.getUsersIdDistinct()
        let resultado = me.carrito.every((item) => {
          let ids = me.getUsersIdDistinctDia(item.fecha)
          return ids.every((idUsuario) => {
            // let asignacionesUsuario = me.getAsignacionesUsuarioDia(item.fecha, idUsuario)
            return me.estaCompletoMenuUsuarioDia(item.fecha, idUsuario)
          })
        })
        return resultado
      }
    },
    created () {
      const me = this
      localforage.getItem(`proveedor-activo-${me.user._id}`).then((asignacionActiva) => {
        if (asignacionActiva) {
          me.subsidio = asignacionActiva.subsidio
          me.reglas = me.subsidio.comboAsignado.reglas
        } else {
          me.reglas = me.carrito[0].reglas
        }
      })
    },
    beforeRouteLeave (to, from, next) {
      this.$emit('cerrar-modal')
      next()
    }
  }
</script>
<style scoped>
  .m-r-20 {
    padding-right: 20px;
    padding-left: 20px;
  }
  .gris {
    background-color: #eee;
  }
  .btn-eliminar {
    padding-top: 3px;
  }
  .verde {
    color: green;
  }
  .icon-user {
    margin-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// CheckoutAdmin.vue?10ddcf30